import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Bell: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.00567 1.65339C5.06502 0.594039 6.50181 -0.00109863 7.99996 -0.00109863C9.49811 -0.00109863 10.9349 0.594038 11.9943 1.65339C13.0536 2.71274 13.6488 4.14953 13.6488 5.64767V10.6912C13.6488 11.0446 13.7891 11.3836 14.0391 11.6335C14.3226 11.917 14.5455 12.0238 14.8571 12.0238C15.1727 12.0238 15.4286 12.2796 15.4286 12.5952C15.4286 12.9108 15.1727 13.1666 14.8571 13.1666H1.14284C0.827249 13.1666 0.571411 12.9108 0.571411 12.5952C0.571411 12.2796 0.827249 12.0238 1.14284 12.0238C1.4545 12.0238 1.67731 11.917 1.96089 11.6335C2.21079 11.3836 2.35118 11.0446 2.35118 10.6912V5.64767C2.35118 4.14953 2.94633 2.71274 4.00567 1.65339ZM5.99998 15.1429C5.99998 14.6695 6.38374 14.2857 6.85713 14.2857H9.14284C9.61622 14.2857 9.99998 14.6695 9.99998 15.1429C9.99998 15.6162 9.61622 16 9.14284 16H6.85713C6.38374 16 5.99998 15.6162 5.99998 15.1429Z"
      fill="currentColor"
    />
  </svg>
);
